// IMDB Base URL
export const IMDB_BASE_URL = 'https://www.imdb.com/';
export const IMDB_MOVIE_URL: (imdbId: string) => string = (imdbId) => `${IMDB_BASE_URL}title/${imdbId}`;
